/** One-shot browser location (D-05: only after the user taps "Use my location"). */
import type { Located } from './store'

export type LocateError = 'unsupported' | 'denied' | 'unavailable'

export function locate(): Promise<Located> {
  return new Promise((resolve, reject) => {
    const geo = typeof navigator !== 'undefined' ? navigator.geolocation : undefined
    if (!geo) {
      reject('unsupported' satisfies LocateError)
      return
    }
    geo.getCurrentPosition(
      (pos) =>
        resolve({
          // ~11 m precision: well inside what a phone reports, and saved as is (D-77).
          lat: Math.round(pos.coords.latitude * 1e4) / 1e4,
          lng: Math.round(pos.coords.longitude * 1e4) / 1e4,
          accuracyM: Number.isFinite(pos.coords.accuracy) ? Math.round(pos.coords.accuracy) : null,
        }),
      (err) => reject((err.code === 1 ? 'denied' : 'unavailable') satisfies LocateError),
      // GPS on phones: Wi-Fi/cell positions can be off by up to a kilometre (D-78).
      { enableHighAccuracy: true, timeout: 15_000, maximumAge: 2 * 60_000 },
    )
  })
}
